import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Company from "../pages/company/page";
import Service from "../pages/service/page";
import TestGuide from "../pages/service/test-guide/page";
import GasCorrosionPrice from "../pages/service/test-guide/gas-corrosion";
import EnvTestPrice from "../pages/service/test-guide/env-test";
import Products from "../pages/products/page";
import Report from "../pages/report/page";
import Links from "../pages/links/page";
import Contact from "../pages/contact/page";
import Recruit from "../pages/recruit/page";
import NewsPage from "../pages/news/page";
import FreeTrial from "../pages/service/free-trial";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/company",
    element: <Company />,
  },
  {
    path: "/recruit",
    element: <Recruit />,
  },
  {
    path: "/news",
    element: <NewsPage />,
  },
  {
    path: "/service",
    element: <Service />,
  },
  {
    path: "/service/free-trial",
    element: <FreeTrial />,
  },
  {
    path: "/service/test-guide",
    element: <TestGuide />,
  },
  {
    path: "/service/test-guide/gas-corrosion",
    element: <GasCorrosionPrice />,
  },
  {
    path: "/service/test-guide/env-test",
    element: <EnvTestPrice />,
  },
  {
    path: "/products",
    element: <Products />,
  },
  {
    path: "/report",
    element: <Report />,
  },
  {
    path: "/links",
    element: <Links />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;